import React, { useState } from 'react';
import TotoNavigationGlyph from '../TotoNavigationGlyph';
import useAuthenticatedPhoto from '../../lib/useAuthenticatedPhoto';

export default function NavigationProfileAvatar({ user, photoSource }) {
  const [failedSource, setFailedSource] = useState(null);
  const picture = user?.employee_profile?.picture ?? user?.picture;
  const loadedSource = useAuthenticatedPhoto(photoSource === undefined ? picture : null);
  const source = photoSource === undefined ? loadedSource : photoSource;
  return source && source !== failedSource
    ? <img className="navigation-profile-photo" src={source} alt="" decoding="async" referrerPolicy="no-referrer" onError={() => setFailedSource(source)}/>
    : <TotoNavigationGlyph name="profile" size={32}/>;
}
